
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/schedule",
      function () {
        return require("private-next-pages/phone/schedule/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/schedule"])
      });
    }
  